module.exports = __webpack_public_path__ + "img/profilo_2recruit.322f63b4.png";